import axios from 'axios';

const { VUE_APP_API_BASE_URL, NODE_ENV } = process.env;

axios.defaults.baseURL = VUE_APP_API_BASE_URL;
axios.defaults.headers.common.Authorization = localStorage.getItem('ed-authToken');
console.log('api default', axios.defaults.headers.common.Authorization);

console.log('api_base_url', VUE_APP_API_BASE_URL, NODE_ENV);

export function setAuth() {
  axios.defaults.headers.common.Authorization = localStorage.getItem('ed-authToken');
}

export async function customers() {
  // in case we just signed in,
  // TODO: figure out a pattern becuase the rest will need this to once
  // backends starts checking for authtokens
  axios.defaults.headers.common.Authorization = localStorage.getItem('ed-authToken');
  return axios.get('/api/v1/customers').then(res => res.data);
}

export async function ordersByCustomer(customerId) {
  return axios.get(`/api/v1/customers/${customerId}/orders`).then(res => res.data);
}

export async function orderDetailsByCustomerAndOrder(customerId, orderId) {
  console.log(`fetching order ${orderId} for customer ${customerId}`);
  return axios.get(`/api/v1/customers/${customerId}/orders/${orderId}`).then(res => res.data);
}

export async function fileByOrder(orderId, type, format) {
  return axios.get(`/api/v1/orders/${orderId}/files`, { params: { type, format } }).then(res => res.data);
}

export async function login(username, password) {
  return axios.post('/login', { username, password }).then(res => res.data);
}
export async function authenticate(authToken) {
  console.log(authToken);
  return axios.post('/authenticate', { authToken }).then(res => res.data);
}
export async function postNewUser({ name, email }) {
  console.log(name, email);
  return axios.post('/api/v1/forms/website-user', { name, email }).then(res => res.data);
}

export async function getOrderOptions() {
  return axios.get('/api/v1/order_options').then(res => res.data);
}

export async function submitOrder({
  quoteAmount, quoteNumber, po, notes, details, operationSystem,
}) {
  // TODO: What field is quote number for and how is it different from quote amount
  console.log(quoteNumber);
  const transformedDetails = details.map(item => ({
    Qty: item.qty,
    IBOB: item.size.ibob,
    Room: item.room,
    Chain: `${item.chain.color} ${item.chain.material}`,
    Color: item.fabric.color,
    Style: item.fabric.style,
    Zebra: false,
    Height: `${item.size.height} ${item.size.height_fraction || ''}`,
    Width: `${item.size.width} ${item.size.width_fraction || ''}`,
    Valance: item.valance.type === 'default' ? null : item.valance.type,
    Motorized: false,
    'Chain Length': item.chain.length || null,
    'Valance Size': item.valance.size,
    'Valance Color': item.valance.color,
    'Chain Control': item.chain.direction,
    'Fabric Position': item.fabric.roll,
    notes: item.notes,
  }));

  return axios.post('/api/v1/orders', {
    'Entered By': localStorage.getItem('ed-role') === 'rep' ? localStorage.getItem('ed-username') : 'customer',
    CustID: localStorage.getItem('ed-assumed-customerId'),
    'Quoted Amount': quoteAmount,
    'Special Instructions': notes,
    'PO/SM': po,
    'Order Cat': 'shades',
    Details: transformedDetails,
    HideOnline: false,
    'Order Date': new Date(),
    'Operation System': operationSystem,
  });
}

export async function postLead(lead) {
  console.log(lead);
  return axios.post('/api/v1/sales/leads', lead).then(200);
}
export async function patchLead(leadId, lead) {
  console.log(lead);
  return axios.put(`/api/v1/sales/leads/${leadId}`, lead).then(200);
}
export async function getLeads() {
  return axios.get('/api/v1/sales/leads').then(res => res.data);
}
export async function getEngagements() {
  return axios.get('/api/v1/sales/engagements').then(res => res.data);
}
export async function patchEngagement(leadId, engagementId, data) {
  return axios.put(`/api/v1/sales/leads/${leadId}/engagements/${engagementId}`, data).then(200);
}
export async function postEngagement(leadId, data) {
  return axios.post(`/api/v1/sales/leads/${leadId}/engagements`, data).then(res => res.data);
}

export async function getLeadDetails(leadId) {
  return axios.get(`/api/v1/sales/leads/${leadId}`).then(res => res.data);

}